import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    statisticsBackground: {
        height: '100%',
        backgroundColor: '#F0F0F0',
        padding: '20px'
    },
    assetsBalancesContainer: {
        display: 'flex' as const,
        width: '100%',
        maxHeight: 'fit-content' as const,
        marginBottom: '16px'
    },
    lfStatsContainer: {
        display: 'flex' as const,
        flexFlow: 'column' as const,
        width: '100%',
        maxHeight: 'fit-content' as const
    },
    bottomStatsContainer: { height: '65%' },
    firstColumnStats: { backgroundColor: '#F0F0F0' },
    labeledStatistics: {
        marginBottom: '16px',
        maxHeight: 'fit-content' as const
    },
    labelStats: {
        height: 'fit-content' as const,
        marginRight: '16px',
        '&:last-child': { marginRight: 0 }
    }
});